import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1, BlueButton } from '../../StyledComponents';
import ZeroTouch from '../../../assets/v2/manage/group-18.svg';
import RemoteSupport from '../../../assets/v2/manage/group-14.svg';
import ApplicationLockdown from '../../../assets/v2/manage/group-12.svg';
import DeviceMonitoring from '../../../assets/v2/manage/group-21.svg';
import Features from '../../../assets/v2/kiosk/features.svg';
import DeviceHealthAssessment from '../../../assets/v2/manage/group-22.svg';
import Alerts from '../../../assets/v2/manage/group-52.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import DeviceSecurity from '../../../assets/v2/manage/group-212.svg';
import DeviceGroups from '../../../assets/v2/manage/group-30.svg';
import { navigate } from '@reach/router';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #fff;
  padding-bottom: 0rem !important;
`;

const BlueButtonWrapper = styled.div`
  display: grid;
  background-color: #2a2f46;
  padding-top: 2rem;
  padding-bottom: 2rem;
  align-content: center;
  justify-content: center;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
    background-color: #ffffff;
    padding-top: 0;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 46px;
`;

const GridContainerLaptop = styled.div`
  margin-bottom: -1px;

  @media (max-width: 520px) {
    display: none;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 3rem;
  display: none;
  grid-gap: 6rem 10rem;
  @media (max-width: 520px) {
    display: unset;
  }
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.79;
  letter-spacing: normal;
  text-align: left;
  color: #736e79;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
`;

const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 22px;
  font-weight: 500;
  min-height: 2em;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 520px) {
    min-height: 2.5rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

const SectionTitle = styled(H1)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: center;
  }

  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #5f4aa1;
`;

const GridImage = styled(LazyLoadImage)`
  width: 100%;
  padding-left: 3%;
`;

export default () => (
  <>
    <Section>
      <SectionTitle>Features</SectionTitle>
      <GridContainer>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={ZeroTouch} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Zero-touch Enrollment</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper cloud supports QR code and NFC based enrollment.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={RemoteSupport} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Remote Support</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper cloud supports remote viewing and full control of devices
            deployed in the field.
          </GridItemContent>
        </GridItem>
        <GridItem>
          {' '}
          <ImgWrapper>
            <StyledImg src={ApplicationLockdown} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Application Lockdown</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper cloud allows only admin-approved applications to be installed
            on the device.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceMonitoring} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Monitoring</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Individual device telemetry graphs such as Battery, Memory,
            Connectivity are available on a per device basis
          </GridItemContent>
        </GridItem>{' '}
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceHealthAssessment} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Health Assessment</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper supports basic device commands such as reboot, ping, and erase
            to enable enterprises to manage their device fleet more effectively.
          </GridItemContent>
        </GridItem>{' '}
        <GridItem>
          <ImgWrapper>
            <StyledImg src={Alerts} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Alerts</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper cloud generates critical alerts when devices have security
            risks, if they go offline, or when the battery is in critical
            condition.
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceSecurity} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Security State Assessment</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Esper accesses OS, hardware, and bootloader conditions to generate a
            complete security state assessment
          </GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeviceGroups} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Device Groups</GridTitle>
          </TitlesContainer>
          <GridItemContent>
            Enterprises can group devices based on location.
          </GridItemContent>
        </GridItem>
      </GridContainer>
      <GridContainerLaptop>
        <GridImage alt="" src={Features} />
      </GridContainerLaptop>
    </Section>
    <BlueButtonWrapper>
      <BlueButton
        id="kiosk__signup_for_free"
        onClick={() => navigate('/signup')}
      >
        {' '}
        Sign up for free
      </BlueButton>
    </BlueButtonWrapper>
  </>
);
